import { 
  collection, 
  addDoc, 
  getDocs, 
  query,
  where,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { getAuth, onAuthStateChanged } from 'firebase/auth'; // Import Firebase Auth

// Function to log a visit after checking auth state
export const logVisitIfNotAdmin = async () => {
  return new Promise((resolve) => {
    const auth = getAuth();
    // Wait for auth state to be resolved
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // Only log visit if user is not authenticated
      if (!user) {
        const visitsCollection = collection(db, 'visits');
        addDoc(visitsCollection, {
          timestamp: serverTimestamp(),
          userAgent: navigator.userAgent,
          language: navigator.language,
          referrer: document.referrer
        }).catch(error => {
          console.error('Error logging visit:', error);
        });
      }
      // Clean up subscription
      unsubscribe();
      resolve(); // Resolve the promise
    });
  });
};

// Function to get today's visits
export const getTodaysVisits = async () => {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const visitsCollection = collection(db, 'visits');
    const q = query(
      visitsCollection,
      where('timestamp', '>=', today)
    );
    
    const visitsSnapshot = await getDocs(q);
    return visitsSnapshot.size;
  } catch (error) {
    console.error('Error getting today\'s visits:', error);
    return 0;
  }
};

// Function to get weekly visits
export const getWeeklyVisits = async () => {
  try {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    
    const visitsCollection = collection(db, 'visits');
    const q = query(
      visitsCollection,
      where('timestamp', '>=', oneWeekAgo)
    );
    
    const visitsSnapshot = await getDocs(q);
    return visitsSnapshot.size;
  } catch (error) {
    console.error('Error getting weekly visits:', error);
    return 0;
  }
};

// Function to get monthly visits
export const getMonthlyVisits = async () => {
  try {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    
    const visitsCollection = collection(db, 'visits');
    const q = query(
      visitsCollection,
      where('timestamp', '>=', oneMonthAgo)
    );
    
    const visitsSnapshot = await getDocs(q);
    return visitsSnapshot.size;
  } catch (error) {
    console.error('Error getting monthly visits:', error);
    return 0;
  }
};